<template>
   <form class="container ">
        <div class="form-group">
            <label>Title</label>
            <input type="text" class="form-control" v-model="title">
        </div>
        <div class="form-group">
            <label for="exampleInputPassword1">Description</label>
            <textarea type="text" rows="10" class="form-control" v-model="description" ></textarea>
        </div>
        <div class="form-group">
            <label >Image</label>
            <input type="file" class="form-control"  @change="onChangeFile" >
        </div>
        <div class="form-group">
            <label>url</label>
            <input type="text" class="form-control" v-model="url">
        </div>
        <div class="form-group">
            <label>URL (youtube)</label>
            <input type="text" class="form-control" v-model="urlY" >
        </div>
        <div class="form-group">
            <label >Slide Image</label>
            <input type="file" class="form-control" name="file[]" @change="handleFileChange" multiple/>
        </div>   
        
        <button type="submit" class="btn btn-light me-2" @click.prevent="UpdateBlog">Update</button>
        <button type="button" class="btn btn-light" @click ="$emit('cancel' , {})" >Cancel</button>
    </form> 
</template>
<script>

import axios from 'axios'
import APIs from "@/../config";
export default {
    name: "UpdateBlog" ,
    data() {
        return {
            title : "",
            description : "" , 
            url : "" , 
            urlY: "",
            selectedFile:"",
            selectedFiles: []
        }
    },
    async created(){
        const url = APIs.API_IMAGES + "/" + this.blog.sliderImg[0]
        const fileName = 'myFile.jpg'
        await fetch(url)
        .then(async response => {
            const contentType = response.headers.get('content-type')
            const blob = await response.blob()
            const file = new File([blob], fileName, { contentType, type: "image/jpeg" })
            this.selectedFiles.push(file)
        })

        this.title = this.blog.title
        this.description = this.blog.description
        this.url = this.blog.urlYoutube !== 'NONE' ? this.url : 'NONE'
        this.urlY = this.blog.urlYoutube !== 'NONE' ? 'https://www.youtube.com/watch?v=' + this.blog.urlYoutube : 'NONE'

        console.log('url', url)

        // https://www.youtube.com/watch?v=qP-7GNoDJ5c&list=RDMMqP-7GNoDJ5c&start_radio=1
    },
    props : {
        blog : Object
    },
       methods : {
        onChangeFile(event) {
        this.selectedFiles.push(event.target.files[0])
        },

        handleFileChange(event) {
        for(let  i = 0 ; i < event.target.files.length ; i++)
            this.selectedFiles.push(event.target.files[i])
        // this.selectedFiles = event.target.files

        // console.log("all files", event.target.files.length)
        // console.log("one file", event.target.files[0])
        },
        UpdateBlog(){
            const fd = new FormData()

            for(let i = 0; i < this.selectedFiles.length; i++) {
                fd.append("sliderImg", this.selectedFiles[i]);
            }
            fd.append('title' , this.title)
            fd.append('description' , this.description)
            fd.append('url', this.url == "" ? "NONE" : this.url );
            fd.append("urlYoutube", this.urlY == "" ? "NONE" : this.urlY );

            var get_token = localStorage.getItem('token')
            var user_id = localStorage.getItem('user_id')
            axios.put(`${APIs.API_URL}/blog/${this.blog._id}/${user_id}/`, fd,{
                headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${get_token}`
                }
            })
            .then(()=> {
                 this.$swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: "Updated",
                    showConfirmButton: false,
                    timer: 1500
                });
                this.$emit('refresh')
            })
            .catch((error) => {
                this.$swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: error.response.data.error,
                    showConfirmButton: false,
                    timer: 1500
                });
            })
        }
    }
}
</script>
